import React from "react";
import { Reveal } from "@/components/Reveal";

export const PageHero = ({ overline, title, image, intro }) => (
  <section className="relative pt-40 pb-20 md:pt-52 md:pb-28 overflow-hidden bg-ink text-white">
    {image && (
      <>
        <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover opacity-35" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/40" />
      </>
    )}
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="overline mb-5">{overline}</p>
        <h1 className="font-serif-display font-light text-5xl md:text-7xl leading-[0.95] tracking-tight max-w-4xl">
          {title}
        </h1>
        {intro && (
          <p className="mt-8 max-w-2xl text-white/70 text-lg leading-relaxed font-light">{intro}</p>
        )}
      </Reveal>
    </div>
  </section>
);
